<template>
    <nav>
        <div class="left-nav">
            <page-link page="HomePage">
                <img class="mccluskey_banner" src="/img/mc_chevrolet.jpg">
            </page-link>
        </div>

        <div v-if="isAuthenticated" class="middle-nav">
            <slot>
                <div class="header-widgets">
                    <unsubscribed-numbers></unsubscribed-numbers>
                    <page-link page="NewTripPage">
                        <button>
                            New&nbsp;Trip
                        </button>
                    </page-link>
                    <header-totals></header-totals>
                </div>
            </slot>
        </div>

        <div class="right-nav">
            <page-link v-if="!loginPage || isAuthenticated" page="login">
                {{loginText}}
            </page-link>
            <div v-if="isAuthenticated">
                <page-link page="TripsPage">
                    Trip View
                </page-link> |
                <a target="_new" :href="usersAdminURL">
                    Users
                </a>
            </div>
        </div>
    </nav>
</template>

<script>
    import config from '../config'
    import PageLink from './PageLink.vue'
    import UnsubscribedNumbers from './UnsubscribedNumbers.vue' 
    import HeaderTotals from './HeaderTotals.vue'

    export default {
        components: {
            'page-link': PageLink,
            'unsubscribed-numbers': UnsubscribedNumbers,
            'header-totals': HeaderTotals
        },
        computed: {
            authenticatedUser() {
                return this.$privateReactiveStore.getUser();
            },
            loginText () {
                return (this.authenticatedUser) ? 'Logged in as ' + this.authenticatedUser.email : "Login"
            },
            usersAdminURL() {
                return `${config.config.stockbookUrl}/users`;
            },
            isAuthenticated() {
                return this.$privateReactiveStore.isUserAuthenticated();
            },
            loginPage() {
                //console.log("CHECKING IF ON LOGIN PAGE " + JSON.stringify(this.$router.currentRoute));
                return this.$router.currentRoute.name == "login"
            }
        },
        methods: {
            testNotification() {
                pushNotify();
            }
        }
    }

    $(document).ready(function() {
        Push.Permission.request();
        
        if (Push.Permission.get() == 'granted') {
            $('#notification').html('');
        } 
        else {
            $('#notification').html('New Trip Notifications not enabled please view page for instructions to turn on.<br /><a href="https://support.google.com/chrome/answer/3220216" target="_blank">Directions to Enable</a>');
        }
    });

    function pushNotify() {
        Push.create('Test Notification', {
            body: 'Click Here to reload the page.',
            icon: '/img/refresh.png',
            link: '/trips',
            timeout: 8000,
            vibrate: [100, 100, 100],
            onClick: function() {
                window.focus();
                this.close();
                window.open(window.location.origin+'/trips','_self');
            }
        });
    }
</script>

<style lang="less">
    nav {
        height: 107px;
        height: -moz-fit-content;
        height: -webkit-fit-content;
        height: fit-content;
        width: 100%;
        background-color: black;
        color: white;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-around;
        a {
            color: white;
            &:hover {
                text-decoration: underline;
            }
        }
        @media (max-width: 1170px) {
            flex-direction: row;
        }
        .left-nav {
            flex-grow: 0;
            img[src='/img/mc_chevrolet.jpg'] {
                @media(min-width: 850px){
                  height: 80%;
                }
            }
        }
        .middle-nav {
            flex: 1;
            font-size: 1.2em;
            text-align: center;
            margin-top: 0;
            padding-top: 0;
            width: 100%;
            align-self: stretch;
            h1 {
                padding-top: 0;
            }
        }
        .right-nav {
            align-self: flex-start;
            order:3;
        }

        .header-widgets {
            display: flex;
            justify-content: flex-start;
            @media (max-width: 270px) {
                justify-content: space-around;
            }
            align-self: stretch;
            align-items: center;
            height: 100%;
            padding: .05em;
            button {
                @media (max-width: 1270px) {
                    align-self: stretch;
                    flex-grow: 1;
                }
            }
        }

        @media(max-width: 850px){
            nav {
                height: 50px;
            }
            .right-nav, .left-nav {
                display:none;
            }
            .middle-nav{
                padding: 2px 0px;
                .header-widgets {
                    padding: 0px 0px;
                }
                img {
                    width: 85%;
                }
            }
        }
    }
</style>
